/* Styled Components */
import {
  AutocompleteResult,
  AutocompleteResultMainText,
  AutocompleteResultSecondaryText,
} from 'styles/signup/Autocomplete';

/* Child Components */
import BoldMatchedSubstrings from 'components/signup/autocomplete/BoldMatchedSubstrings';

/* Types */
import type { PlaceAutocompletePredictionType } from 'types/GooglePlacesTypes';

/* Constants */
import KEYCODES from 'constants/KeyCodeConstants';

type PropsType = {
  prediction: PlaceAutocompletePredictionType;
  onClick: (placeId: string) => void;
  isSelected: boolean;
};

const PlaceAutocompletePrediction = ({
  prediction,
  onClick,
  isSelected,
}: PropsType) => {
  const {
    place_id: placeId,
    structured_formatting: {
      main_text: mainText,
      main_text_matched_substrings: mainTextMatchedSubstrings,
      secondary_text: secondaryText,
    },
  } = prediction;

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if ((event.keyCode || event.charCode) === KEYCODES.ENTER) {
      onClick(placeId);
    }
  };

  return (
    <AutocompleteResult
      onClick={() => onClick(placeId)}
      onKeyDown={onKeyDown}
      isSelected={isSelected}
    >
      <AutocompleteResultMainText>
        <BoldMatchedSubstrings
          text={mainText}
          matchedSubstrings={mainTextMatchedSubstrings}
        />
      </AutocompleteResultMainText>
      <AutocompleteResultSecondaryText>
        {secondaryText}
      </AutocompleteResultSecondaryText>
    </AutocompleteResult>
  );
};

export default PlaceAutocompletePrediction;
